import { useEffect } from 'react';
import { Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { breadcrumbAction, tabNavigationAction } from '../../../_actions';
import Loader from '../../../components/Loader';
import { questionnaireDetailActions } from '../../../_actions/questionnaireDetail.actions';
import { getQuestionnaireDetailsNavigationItem } from './utils';
import QuestionnaireDetail from './QuestionnaireDetail';

const QuestionnaireDetails = () => {
  const { questionnaireStore: { questionnaireDetails: { questionnaireDetails, loadingQuestionnaireDetails } } } = useSelector(state => state)

  const dispatch = useDispatch()
  const { questionnaireId } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    const questionnaireDetailsNavigation = getQuestionnaireDetailsNavigationItem(t)
    dispatch(tabNavigationAction.setNavigationTab(questionnaireDetailsNavigation.tabs))
    dispatch(breadcrumbAction.setBreadcrumbItem(questionnaireDetailsNavigation.breadCrumbs))
  }, [dispatch, t, questionnaireDetails])

  useEffect(() => {
    return () => {
      dispatch(questionnaireDetailActions.clearQuestionnaireDetailsStore())
    }
  }, [])

  useEffect(() => {
    if (questionnaireId) {
      dispatch(questionnaireDetailActions.fetchQuestionnaireDetails(questionnaireId))
    }
  }, [dispatch, questionnaireId])

  return <Stack height={"100%"} >
    {loadingQuestionnaireDetails && <Loader />}
    {!loadingQuestionnaireDetails && <QuestionnaireDetail />}
  </Stack>
}

export default QuestionnaireDetails
